import axios from "axios";
import {
  SEND_MESSAGE_REQUEST,
  SEND_MESSAGE_SUCCESS,
  SEND_MESSAGE_FAILURE,
  GET_ALL_SESSIONS_REQUEST,
  GET_ALL_SESSIONS_SUCCESS,
  GET_ALL_SESSIONS_FAILURE,
  GET_SESSION_HISTORY_REQUEST,
  GET_SESSION_HISTORY_SUCCESS,
  GET_SESSION_HISTORY_FAILURE,
  CREATE_SESSION_REQUEST,
  CREATE_SESSION_SUCCESS,
  CREATE_SESSION_FAILURE,
  DELETE_SESSION_REQUEST,
  DELETE_SESSION_SUCCESS,
  DELETE_SESSION_FAILURE,
  CLEAR_ALL_SESSIONS_REQUEST,
  CLEAR_ALL_SESSIONS_SUCCESS,
  CLEAR_ALL_SESSIONS_FAILURE,
} from "./aiChatBotTypes";

import Config from "../../config/index";

const URL = Config.baseUrl;
const AiAgentUrl = Config.AiAgentUrl;

const sendMessageRequest = () => {
  return { type: SEND_MESSAGE_REQUEST };
};

const sendMessageSuccess = (payload) => {
  return { type: SEND_MESSAGE_SUCCESS, payload: payload };
};

const sendMessageFailure = (error) => {
  return { type: SEND_MESSAGE_FAILURE, payload: error };
};

const sendMessage = (payloadData) => {
  return async (dispatch) => {
    dispatch(sendMessageRequest());

    let url = `${AiAgentUrl}/run`;

    const apiPayload = {
      appName: "chat_boat_sql",
      userId: payloadData.userId,
      sessionId: payloadData.sessionId,
      // sessionId: "55d9ab20-c36a-4b6d-bfe4-3e67d4f2b149",
      newMessage: {
        parts: [
          {
            text: payloadData.message,
          },
        ],
      },
      streaming: false,
      stateDelta: {
        additionalProp1: {},
      },
    };

    try {
      const response = await axios.post(url, apiPayload);
      const dataArray = response.data;

      let botText = "Sorry, I couldn't find any data.";
      const textMessage = [...dataArray]
        .reverse()
        .find(
          (item) =>
            item.content &&
            item.content.role === "model" &&
            item.content.parts &&
            item.content.parts[0].text
        );

      if (textMessage) {
        botText = textMessage.content.parts[0].text;
      } else {
        const functionMessage = [...dataArray]
          .reverse()
          .find(
            (item) =>
              item.content &&
              item.content.role === "user" &&
              item.content.parts &&
              item.content.parts[0].functionResponse
          );

        if (functionMessage) {
          const rawResult =
            functionMessage.content.parts[0].functionResponse.response.result;
          if (rawResult) {
            botText = rawResult;
          }
        }
      }

      dispatch({ type: SEND_MESSAGE_SUCCESS, payload: botText });
      return botText;
    } catch (err) {
      const errorMessage = err.message || "Something went wrong";
      dispatch({ type: SEND_MESSAGE_FAILURE, payload: errorMessage });
      throw err;
    }
  };
};

// 2. GET ALL SESSIONS (SIDEBAR)

const getAllSessionsRequest = () => {
  return { type: GET_ALL_SESSIONS_REQUEST };
};

const getAllSessionsSuccess = (payload) => {
  return { type: GET_ALL_SESSIONS_SUCCESS, payload: payload };
};

const getAllSessionsFailure = (error) => {
  return { type: GET_ALL_SESSIONS_FAILURE, payload: error };
};

const getAllSessions = (userId) => {
  // let url = `${AiAgentUrl}/list_session?userId=${userId}`;
  let url = `${AiAgentUrl}/apps/chat_boat_sql/users/${userId}/sessions`;
  
  return (dispatch) => {
    dispatch(getAllSessionsRequest());

    axios
      .get(url)
      .then((response) => {
        dispatch(getAllSessionsSuccess(response.data));
      })
      .catch((err) => {
        const errorMsg =
          err.response && err.response.data && err.response.data.message
            ? err.response.data.message
            : err.message;
        dispatch(getAllSessionsFailure(errorMsg));
      });
  };
};

// 3. GET SESSION HISTORY

const getSessionHistoryRequest = () => ({ type: GET_SESSION_HISTORY_REQUEST });
const getSessionHistorySuccess = (payload) => ({
  type: GET_SESSION_HISTORY_SUCCESS,
  payload,
});
const getSessionHistoryFailure = (error) => ({
  type: GET_SESSION_HISTORY_FAILURE,
  payload: error,
});

const getSessionHistory = (userId, sessionId) => {
  return (dispatch) => {
    dispatch(getSessionHistoryRequest());

    // let url = `${AiAgentUrl}/get_session?userId=${userId}&sessionId=${sessionId}`;
    let url = `${AiAgentUrl}/apps/chat_boat_sql/users/${userId}/sessions/${sessionId}`;

    axios
      .get(url)
      .then((response) => {
        const sessionData = response.data;
        let formattedMessages = [];

        if (sessionData.events && Array.isArray(sessionData.events)) {
          const allEvents = sessionData.events.map((event) => {
            const part = event.content.parts ? event.content.parts[0] : null;

            const role = event.content.role === "model" ? "bot" : "user";

            let messageText = null;
            if (part) {
              if (part.text) {
                messageText = part.text;
              }
            }
            if (!messageText) return null;

            return {
              id: event.id || Date.now() + Math.random(),
              text: messageText,
              sender: role,
              type: "text",
              timestamp: event.timestamp
                ? new Date(event.timestamp * 1000).toLocaleTimeString([], {
                    hour: "2-digit",
                    minute: "2-digit",
                  })
                : "",
            };
          });
          formattedMessages = allEvents.filter(
            (msg) => msg !== null && msg.text && msg.text.trim() !== ""
          );
        }

        dispatch(
          getSessionHistorySuccess({
            sessionId: sessionId,
            messages: formattedMessages,
          })
        );
      })
      .catch((err) => {
        const errorMsg =
          err.response && err.response.data && err.response.data.message
            ? err.response.data.message
            : err.message;
        dispatch(getSessionHistoryFailure(errorMsg));
      });
  };
};
const createSessionRequest = () => {
  return { type: CREATE_SESSION_REQUEST };
};

const createSessionSuccess = (payload) => {
  return { type: CREATE_SESSION_SUCCESS, payload: payload };
};

const createSessionFailure = (error) => {
  return { type: CREATE_SESSION_FAILURE, payload: error };
};

const createNewSession = (userId) => {
  return (dispatch) => {
    dispatch(createSessionRequest());
    // let url = `${AiAgentUrl}/create_session?userId=${userId}`;
    let url = `${AiAgentUrl}/apps/chat_boat_sql/users/${userId}/sessions`;

    return axios
      .post(url, {})
      .then((response) => {
        dispatch(createSessionSuccess(response.data));
        return response.data;
      })
      .catch((err) => {
        const errorMsg =
          err.response && err.response.data && err.response.data.message
            ? err.response.data.message
            : err.message;
        dispatch(createSessionFailure(errorMsg));
      });
  };
};

const deleteSessionRequest = () => {
  return { type: DELETE_SESSION_REQUEST };
};

const deleteSessionSuccess = (sessionId) => {
  return { type: DELETE_SESSION_SUCCESS, payload: sessionId };
};

const deleteSessionFailure = (error) => {
  return { type: DELETE_SESSION_FAILURE, payload: error };
};

const deleteSession = (userId, sessionId) => {
  return (dispatch) => {
    dispatch(deleteSessionRequest());
    // let url = `${AiAgentUrl}/delete_session?userId=${userId}&sessionId=${sessionId}`;
    let url = `${AiAgentUrl}/delete_session?userId=${userId}&sessionId=${sessionId}`;
    axios
      .delete(url)
      .then((response) => {
        dispatch(deleteSessionSuccess(sessionId));
      })
      .catch((err) => {
        const errorMsg =
          err.response && err.response.data && err.response.data.message
            ? err.response.data.message
            : err.message;
        dispatch(deleteSessionFailure(errorMsg));
      });
  };
};

const clearAllSessionsRequest = () => {
  return { type: CLEAR_ALL_SESSIONS_REQUEST };
};

const clearAllSessionsSuccess = () => {
  return { type: CLEAR_ALL_SESSIONS_SUCCESS };
};

const clearAllSessionsFailure = (error) => {
  return { type: CLEAR_ALL_SESSIONS_FAILURE, payload: error };
};

const clearAllSessions = (userId) => {
  return (dispatch) => {
    dispatch(clearAllSessionsRequest());
    let url = `${AiAgentUrl}/deleteAll_session?userId=${userId}`;
    // let url = `${AiAgentUrl}/apps/chat_boat_sql/users/${userId}/sessions/${sessionId}`;
    
    return axios
      .delete(url)
      .then((response) => {
        dispatch(clearAllSessionsSuccess());
        return true;
      })
      .catch((err) => {
        const errorMsg =
          err.response && err.response.data && err.response.data.message
            ? err.response.data.message
            : err.message;
        dispatch(clearAllSessionsFailure(errorMsg));
        return false;
      });
  };
};

export {
  sendMessage,
  getAllSessions,
  getSessionHistory,
  createNewSession,
  deleteSession,
  clearAllSessions,
};
